// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea {
  min-height: 200px;
}

.inp {
  width: 360px;
}

.parent {
  position: relative;
}

.child {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.fixed {
  position: sticky;
  top: 0;
  z-index: 999;
}

.option {
  border: 1.5px solid rgba(222, 219, 219, 0.87);
}

.option:hover {
  background-color: #f0f0f0;
}

.bar-section {
  max-width: 1400px;
  background: #ffffff;
  border-radius: 3px;
  padding: 0; /* Remove padding to eliminate extra space */
  margin-top: 5px;
}

.bar-section .row {
  margin: 0; /* Remove default row margin */
}

.bar-section .tab-column {
  background-color: #A4B4BF; /* Default background color */
  color: white; /* Default text color */
  cursor: pointer;
  text-align: center;
  padding: 10px;
  font-size: 16px;
  border: 1px solid rgb(204, 202, 202);
  border-radius: 3px;
  transition: background-color 0.3s ease;
}

.bar-section .tab-column:hover {
  background-color: #6f8fa4; /* Darker shade on hover */
}

.bar-section .tab-column.active {
  background-color: #0060d6; /* Active tab background color */
  color: white; /* Active tab text color */
  font-weight: bold;
}

.btn-submit {
  background-color: #0060d6;
  color: white;
  transition: background 0.3s ease-in-out;
}
.btn-submit:hover {
  background-color: #1a1a86;
}

.btn-add {
  background-color: #0f0f70;
  color: white;
  transition: background 0.3s ease-in-out;
}
.btn-add:hover {
  background-color: #0b0b53;
}`, "",{"version":3,"sources":["webpack://./src/app/features/ada-access/adaptive-access-node/adaptive-access-node-create-or-update/adaptive-access-node-create-or-update.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AACF;;AAEA;EACE,gBAAA;EACA,MAAA;EACA,YAAA;AACF;;AAEA;EACE,6CAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAGA;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA,EAAA,4CAAA;EACA,eAAA;AAAF;;AAGA;EACE,SAAA,EAAA,8BAAA;AAAF;;AAGA;EACE,yBAAA,EAAA,6BAAA;EACA,YAAA,EAAA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,sCAAA;AAAF;;AAGA;EACE,yBAAA,EAAA,0BAAA;AAAF;;AAGA;EACE,yBAAA,EAAA,gCAAA;EACA,YAAA,EAAA,0BAAA;EACA,iBAAA;AAAF;;AAIA;EACE,yBAAA;EACA,YAAA;EACA,uCAAA;AADF;AAGE;EACE,yBAAA;AADJ;;AAMA;EACE,yBAAA;EACA,YAAA;EACA,uCAAA;AAHF;AAKE;EACG,yBAAA;AAHL","sourcesContent":["textarea {\n  min-height: 200px;\n}\n\n.inp {\n  width: 360px;\n}\n\n.parent {\n  position: relative;\n}\n\n.child {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.fixed {\n  position: sticky;\n  top: 0;\n  z-index: 999;\n}\n\n.option {\n  border: 1.5px solid rgba(222, 219, 219, 0.87);\n}\n\n.option:hover {\n  background-color: #f0f0f0;\n}\n\n\n.bar-section {\n  max-width: 1400px;\n  background: #ffffff;\n  border-radius: 3px;\n  padding: 0; /* Remove padding to eliminate extra space */\n  margin-top: 5px;\n}\n\n.bar-section .row {\n  margin: 0; /* Remove default row margin */\n}\n\n.bar-section .tab-column {\n  background-color: #A4B4BF; /* Default background color */\n  color: white; /* Default text color */\n  cursor: pointer;\n  text-align: center;\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid rgb(204, 202, 202);\n  border-radius: 3px;\n  transition: background-color 0.3s ease;\n}\n\n.bar-section .tab-column:hover {\n  background-color: #6f8fa4; /* Darker shade on hover */\n}\n\n.bar-section .tab-column.active {\n  background-color:#0060d6; /* Active tab background color */\n  color: white; /* Active tab text color */\n  font-weight: bold;\n}\n\n\n.btn-submit {\n  background-color: #0060d6;\n  color: #ffff;\n  transition: background 0.3s ease-in-out;\n\n  &:hover{\n    background-color: #1a1a86;\n  }\n}\n\n\n.btn-add {\n  background-color: #0f0f70;\n  color: #ffff;\n  transition: background 0.3s ease-in-out;\n\n  &:hover{\n     background-color: #0b0b53;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
